module.exports = __webpack_public_path__ + "img/image3.a94c9a92.jpg";